import { useEffect } from 'react';

/** Pages name themselves; the tab reads "<page> · Agents by Stratika". */
export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    document.title = title ? `${title} · Agents by Stratika` : 'Agents by Stratika';
  }, [title]);
}
